import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axiosConfig from './axios-config'
import store from './store'
import { Transition } from 'vue'
import Loading from './components/loading-component/loading';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import '@sweetalert2/theme-dark/dark.css'

import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

const app = createApp(App);

axiosConfig();

app.use(router);
app.use(store);

app.component('Transition', Transition);
app.component('Loading-Style', Loading);
app.component('Vue-select', VueSelect);

app.mount('#app');
